export class BuybackSettings {
  private readonly customerIdentityDocumentRequired: boolean;
  private readonly minimumCartValue: number;

  constructor(customerIdentityDocumentRequired: boolean, minimumCartValue: number) {
    this.customerIdentityDocumentRequired = customerIdentityDocumentRequired;
    this.minimumCartValue = minimumCartValue;
  }

  isCustomerIdentityDocumentRequired(): boolean {
    return this.customerIdentityDocumentRequired;
  }

  getMinimumCartValueAsDecimal(): number {
    return this.minimumCartValue;
  }
}
